// From the pure schema entry of platform: this file is bundled into the web app through ./schema.
import { definePermissions } from '@mkcore/platform/schema';

/**
 * Permissions of the feedback module (CO-0398). Reporting is open to every signed-in person and agent; reading all
 * reports, triage and deletion are for the team. The issue mirror of U2 adds its own module `dev`.
 */
export const feedbackPermissions = definePermissions('feedback', {
  read: 'View all feedback, not only your own',
  create: 'Report a bug, a feature request or a question',
  update: 'Triage feedback (status, kind, severity, area, note) and send it to Forgejo',
  delete: 'Delete feedback that is not in Forgejo yet',
});

/**
 * Permissions of the issue mirror (U2, ADR-0003). read: issues, labels, milestones and the sync status; create and
 * update: write-through to the forge with the account of the user; manage: which organisations and repositories are
 * mirrored, label groups and starting a sync.
 */
export const devPermissions = definePermissions('dev', {
  read: 'View the mirrored repositories, issues, labels, milestones and the sync status',
  create: 'Create issues and comments in the forge through the app',
  update: 'Change issues (title, body, state, labels, milestone, assignees) in the forge through the app',
  delete: 'Delete comments in the forge through the app',
  approve: 'Merge a pull request in the forge through the app, with your own account; never an agent (CO-1238)',
  manage: 'Choose the mirrored organisations and repositories, manage label groups and start a sync',
});
